import { render, staticRenderFns } from "./RankedResultChart.vue?vue&type=template&id=3176d4e0&"
import script from "./RankedResultChart.vue?vue&type=script&lang=js&"
export * from "./RankedResultChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports